import React, { Component } from "react";
import ShowCorresponseProvider from "../common/timeline";
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import DoNotDisturbIcon from '@mui/icons-material/DoNotDisturb';
import { requestHistory } from "../../../services/insurance/requestHistory";
import { getAge, getDateObj, getCustomApptDate } from "../../../services/insurance/common";
import { USER } from "../../../constants/insurance/constant";
import { MaskElement } from "../../../services/insurance/common";
import ArrowLeftOutlinedIcon from '@mui/icons-material/ArrowBackTwoTone';
import { communicationHistory, getDownloadEmail } from "../../../services/insurance/correspondence";
import ShowCommunicationHistory from "../dialogs/communication-history";

import CloseIcon from '@mui/icons-material/Close';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import ChatIcon from '@mui/icons-material/Chat';
import EmailIcon from '@mui/icons-material/Email';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import CallIcon from '@mui/icons-material/Call';
import HeadsetMicIcon from '@mui/icons-material/HeadsetMic';
import Tooltip from '@mui/material/Tooltip';
import { InsurerErIDs } from "../../../constants/provider/constant";
class RequestProviderHistory extends Component {
  constructor(props) {
    super(props);
    this.state = {
      requestId: this.props.match.params.requestId ? this.props.match.params.requestId : null,
      historyDetails: null,
      dcLogin: USER.user && USER.user.roleId && USER.user.roleId === 5432 ? true : false,
      communicationHistory: "",
      showCommunicationModal: false,
      source: (this.props.location?.state?.sourceType || this.props.location?.state?.sourceName || this.props.location?.state?.source) +' | '+ (this.props.location?.state?.source === 1000042 ? 'EDW File' : 'API') ,
    }
  }

  componentDidMount() {
    console.log("requestId", this.state.requestId)
    if (this.state.requestId != null && this.state.history == null) {
      this.getHistory();
    }
  }

  getCommHistory = () => {
    communicationHistory(this.state.requestId).then(res => {
      this.setState({ communicationHistory: this.getCountObject(res.communicationDetails) })
    })
  }
  getCountObject = (data) => {
    let obj = {};
    data.map(ele => {
      if (obj[ele.communicationTypeValue])
        obj[ele.communicationTypeValue] += 1
      else
        obj[ele.communicationTypeValue] = 1;
    });
    return obj;
  }
  getHistory() {
    requestHistory(this.state.requestId).then(response => {
      console.log("response.data", response)
      if (response && response.isSuccess) {
        this.setState({
          historyDetails: response,
          visitType: response.requestHistory.additionalInformation.visitType,
          visitTypeData: response.requestHistory.additionalInformation,
          providerId: response.requestHistory.additionalInformation.providerId,
          providerName: response.requestHistory.additionalInformation.providerName,
          appointmentDate: response.requestHistory.additionalInformation.appointmentDate,
          statusHistory: response.requestHistory.statusHistory,
          isVisitType: response.requestHistory.additionalInformation.visitType === 'Home_Visit' ? true : false,
          primaryEntityId: response.requestHistory.additionalInformation.primaryEntityId
        });
        this.getDetails();
        this.getCommHistory();
      }
      else {
        this.props.history.push('/insureradmin/appointments');
      }
    })
  }

  getDetails() {
    if (this.state.historyDetails && this.state.historyDetails.requestHistory != null) {
      let history = this.state.historyDetails.requestHistory;

      let customerDetails = {
        patientName: this.state.historyDetails.requestHistory.additionalInformation.patientName ? this.state.historyDetails.requestHistory.additionalInformation.patientName : '--',
        gender: this.state.historyDetails.requestHistory.additionalInformation.gender,
        age: getAge(this.state.historyDetails.requestHistory.additionalInformation.dob),
        employeeID: this.state.historyDetails.requestHistory.additionalInformation.employeeID ? this.state.historyDetails.requestHistory.additionalInformation.employeeID : '--',
        relation: this.state.historyDetails.requestHistory.additionalInformation.relation ? this.state.historyDetails.requestHistory.additionalInformation.relation : '--',
        employeeMailID: this.state.historyDetails.requestHistory.additionalInformation.employeeMailID ? this.state.historyDetails.requestHistory.additionalInformation.employeeMailID.toLowerCase() : "--",
        contactNo: this.state.historyDetails.requestHistory.additionalInformation.contactNo ? this.state.historyDetails.requestHistory.additionalInformation.contactNo : '--',
        addressLine1: this.state.historyDetails.requestHistory.additionalInformation.addressLine1 ? this.state.historyDetails.requestHistory.additionalInformation.addressLine1 : '--',
        addressLine2: this.state.historyDetails.requestHistory.additionalInformation.addressLine2 ? this.state.historyDetails.requestHistory.additionalInformation.addressLine2 : '--',
        pharmaPrescription: this.state.historyDetails.requestHistory.additionalInformation.additionals ? (this.state.historyDetails.requestHistory.additionalInformation.additionals.PharmaOrderPrescriptionFiles ? this.state.historyDetails.requestHistory.additionalInformation.additionals.PharmaOrderPrescriptionFiles : '--') : '--',
        additionals: this.state.historyDetails.requestHistory.additionalInformation.additionals ? this.state.historyDetails.requestHistory.additionalInformation.additionals : null,
      }

      let apptEssentials = {
        packageType: (this.state.historyDetails.requestHistory.additionalInformation.isPaid === true) ? true : false,
        visitType: this.state.historyDetails.requestHistory.additionalInformation.visitType ? this.state.historyDetails.requestHistory.additionalInformation.visitType : '',
        productName: this.state.historyDetails.requestHistory.additionalInformation.productName ? this.state.historyDetails.requestHistory.additionalInformation.productName : '',
        productType: this.state.historyDetails.requestHistory.additionalInformation.productType ? this.state.historyDetails.requestHistory.additionalInformation.productType : '',
        additionals: this.state.historyDetails.requestHistory.additionalInformation.additionals ? this.state.historyDetails.requestHistory.additionalInformation.additionals : '',
        providerOrderId: this.state.historyDetails.requestHistory.providerOrderId,
        nextPosibleActions: this.state.historyDetails.requestHistory.nextPossibleActions,
        fitUnfit: this.state.historyDetails.requestHistory.fitUnfit,
        previousID: this.state.historyDetails.requestHistory.additionalInformation.previousID,
        priorityId: this.state.historyDetails.requestHistory.priorityId,
        maid: this.state.historyDetails.requestHistory.additionalInformation.maid,
        secondAppointmentDate: this.state.historyDetails.requestHistory.additionalInformation.secondAppointmentDate,
        productId: this.state.historyDetails.requestHistory.additionalInformation.splittedRequestDetails === undefined ? this.state.historyDetails.requestHistory.additionalInformation.orderItemProductId : this.state.historyDetails.requestHistory.additionalInformation.splittedRequestDetails,
        grade: this.state.historyDetails.requestHistory.additionalInformation.grade ? this.state.historyDetails.requestHistory.additionalInformation.grade : ''
      }

      let apptDetails = {
        appointmentDate: this.state.historyDetails.requestHistory.additionalInformation.appointmentDate,
        appointmentTime: this.state.historyDetails.requestHistory.additionalInformation.appointmentDate,
        firstPreferredDate: this.state.historyDetails.requestHistory.additionalInformation.firstAppointmentDate ? this.state.historyDetails.requestHistory.additionalInformation.firstAppointmentDate : null,
        secondPreferredDate: this.state.historyDetails.requestHistory.additionalInformation.secondAppointmentDate ? this.state.historyDetails.requestHistory.additionalInformation.secondAppointmentDate : null,
        providerName: this.state.historyDetails.requestHistory.additionalInformation.providerName ? this.state.historyDetails.requestHistory.additionalInformation.providerName : '--',
        requestDCLocation: this.state.historyDetails.requestHistory.requestDCLocation ? this.state.historyDetails.requestHistory.requestDCLocation : '--',
        primaryContactName: this.state.historyDetails.requestHistory.primaryContactName ? this.state.historyDetails.requestHistory.primaryContactName : '--',
        primaryContactNo: this.state.historyDetails.requestHistory.primaryContactNo ? this.state.historyDetails.requestHistory.primaryContactNo : '--',
        dcLandlineNo: this.state.historyDetails.requestHistory.additionalInformation.dcLandlineNo ? this.state.historyDetails.requestHistory.additionalInformation.dcLandlineNo : null,
        dcMobileNo: this.state.historyDetails.requestHistory.additionalInformation.dcMobileNo ? this.state.historyDetails.requestHistory.additionalInformation.dcMobileNo : null,
        orderItemProductId: this.state.historyDetails.requestHistory.additionalInformation.orderItemProductId ? this.state.historyDetails.requestHistory.additionalInformation.orderItemProductId : '',
        primaryEmail: this.state.historyDetails.requestHistory.primaryEmail ? this.state.historyDetails.requestHistory.primaryEmail : '--',
        isHNI: this.state.historyDetails.requestHistory.additionalInformation.priorityForRequest && this.state.historyDetails.requestHistory.additionalInformation.priorityForRequest.priorityName && this.state.historyDetails.requestHistory.additionalInformation.priorityForRequest.priorityName.toUpperCase().indexOf("HNI") > -1 ? true : false,
        isDND: this.state.historyDetails.requestHistory.additionalInformation.additionals.DND === 'true' ? true : false,
        isDNDCustomer: this.state.historyDetails.requestHistory.additionalInformation.additionals.DNDCustomer === 'true' ? true : false,
        statusHistory: this.state.historyDetails.requestHistory.statusHistory.map(function (e) {
          return {
            statusId: e.statusId
          };
        }),
        additionalInformation: this.state.historyDetails.requestHistory.additionalInformation ? this.state.historyDetails.requestHistory.additionalInformation : {}
      };

      let pharmaDetails = {
        PharmaOrderPrescriptionFiles: this.state.historyDetails.requestHistory.additionalInformation.additionals ? (this.state.historyDetails.requestHistory.additionalInformation.additionals.PharmaOrderPrescriptionFiles ? this.state.historyDetails.requestHistory.additionalInformation.additionals.PharmaOrderPrescriptionFiles : '') : '',
        remarks: this.state.historyDetails.requestHistory.additionalInformation.additionals ? (this.state.historyDetails.requestHistory.additionalInformation.additionals.MedicineRemarks ? this.state.historyDetails.requestHistory.additionalInformation.additionals.MedicineRemarks : '') : '',
        cod: this.state.historyDetails.requestHistory.additionalInformation.lineAmount ? this.state.historyDetails.requestHistory.additionalInformation.lineAmount : '',
        cashless: this.state.historyDetails.requestHistory.additionalInformation.cashlessAmount ? this.state.historyDetails.requestHistory.additionalInformation.cashlessAmount : '',
        productType: this.state.historyDetails.requestHistory.additionalInformation.productType ? this.state.historyDetails.requestHistory.additionalInformation.productType : '',
        medicineData: this.state.historyDetails.requestHistory.additionalInformation.medicineData ? this.state.historyDetails.requestHistory.additionalInformation.medicineData : '',
        pharmacyOrderId: this.state.historyDetails.requestHistory.pharmacyOrderId ? this.state.historyDetails.requestHistory.pharmacyOrderId : ''
      }

      let apptHistory = {
        statusHistory: this.state.historyDetails.requestHistory.statusHistory,
        isPaid: this.state.historyDetails.requestHistory.additionalInformation.isPaid,
        cod: this.state.historyDetails.requestHistory.additionalInformation.lineAmount ? this.state.historyDetails.requestHistory.additionalInformation.lineAmount : '',
        cashless: this.state.historyDetails.requestHistory.additionalInformation.cashlessAmount ? this.state.historyDetails.requestHistory.additionalInformation.cashlessAmount : '',
        productType: this.state.historyDetails.requestHistory.additionalInformation.productType ? this.state.historyDetails.requestHistory.additionalInformation.productType : '',
        additionals: this.state.historyDetails.requestHistory.additionalInformation ? this.state.historyDetails.requestHistory.additionalInformation : ''
      };

      this.setState({
        customerDetails: customerDetails,
        apptEssentials: apptEssentials,
        apptDetails: apptDetails,
        apptHistory: apptHistory,
        pharmaDetails: pharmaDetails,
        visitType: history.additionalInformation.visitType,
        visitTypeData: history.additionalInformation,
        dcLandlineNo: history.dcLandlineNo,
        providerId: history.additionalInformation.providerId,
        providerName: history.additionalInformation.providerName,
        appointmentDate: history.additionalInformation.appointmentDate,
        statusHistory: history.statusHistory,
        isVisitType: history.additionalInformation.visitType === 'Home_Visit' ? true : false,
      })
    }
  }

  renderCustomerDetails() {
    return (
      <div>
        {this.state.customerDetails && this.state.apptDetails ?
          <div className="border-2 border-gray-300 p-4 pb-5 w-full text-gray-100 tag-background-card-brown rounded-xl">
            <div>
              <div className="w-full text-center py-4 uppercase text-lg font-bold">
                Customer Details
                <div className="h-px mt-1"></div>
              </div>
              <div>
                <div> <span className="text-gray-400 text-sm">Patient Name :</span>
                  <div>
                    {this.state.customerDetails.patientName}
                  </div>
                </div>

                <div> <span className="text-gray-400 text-sm">Email Id:</span>
                  <div>
                    {MaskElement(this.state.customerDetails.employeeMailID, this.state.historyDetails.requestHistory.additionalInformation.additionals)}
                  </div>
                </div>

                <div> <span className="text-gray-400 text-sm">Contact No :</span>
                  <div>
                    {MaskElement(this.state.customerDetails.contactNo, this.state.historyDetails.requestHistory.additionalInformation.additionals)}
                  </div>
                </div>
                {
                  this.state.visitType && (this.state.visitTypeData.productType === 4625 || this.state.visitTypeData.productType === 9782) ?
                    <div>
                      <div>
                        <span className="text-gray-400 text-sm"> Proposal Number : </span>
                        <div>
                          {this.state.customerDetails.employeeID}
                        </div>
                      </div>
                      <div>
                        <span className="text-gray-400 text-sm"> Member Id / MAID : </span>
                        <div>
                          {this.state.apptDetails.additionalInformation.maid}</div>
                      </div>
                    </div>
                    :
                    <div> <span className="text-gray-400 text-sm"> Employee ID : </span>
                      <div>
                        {this.state.customerDetails.employeeID}</div>
                    </div>
                }


                <div>
                  <span className="text-gray-400 text-sm"> First Preferred Date: </span>
                  <div>
                    {getDateObj(this.state.apptDetails.firstPreferredDate).toLocaleString()}</div>
                </div>
                <div>
                  <span className="text-gray-400 text-sm"> Second Preferred Date: </span>
                  <div>
                    {getDateObj(this.state.apptDetails.secondPreferredDate).toLocaleString()}
                  </div>
                </div>
                <div>
                  <span className="text-gray-400 text-sm"> HNI: </span>
                  <div>
                    {this.state.apptDetails.isHNI ? 'YES' : 'NO'}
                  </div>
                </div>

                {this.state.apptDetails.isDND ?
                  <div>
                    <span className="text-gray-400 text-sm"> DND: </span>
                    <div>
                      YES
                    </div>
                  </div> : ''
                }

                {this.state.apptDetails.isDNDCustomer ?
                  <div>
                    <span className="text-gray-400 text-sm"> DND Customer: </span>
                    <div>
                      YES
                    </div>
                  </div> : ''
                }

              </div>
            </div>
          </div>
          : ''}
      </div>
    )
  }


  renderAppointmentDetails() {
    return (
      <div>
        {this.state.apptDetails ?
          <div className="border-2 border-gray-300 p-4 pb-5 w-full text-gray-100 tag-background-card-blue rounded-xl">
            <div>
              <div className="w-full text-center py-4 uppercase text-lg font-bold">
                Appointment Details
                <div className="h-px mt-1"></div>
              </div>
              <div>
                <div> <span className="text-gray-400 text-sm">Date :</span>
                  <div>
                    {getCustomApptDate(this.state.apptDetails.appointmentDate).toLocaleString()}
                  </div>
                </div>
                <div> <span className="text-gray-400 text-sm">Provider name/ address :</span>
                  <div>
                    {this.state.apptDetails.providerName}, {this.state.apptDetails.requestDCLocation}</div>
                </div>


                <div>
                  <span className="text-gray-400 text-sm"> Provider ID: </span>
                  <div>
                    {this.state.apptDetails.additionalInformation.providerId}</div>
                </div>

                {
                  this.state.apptDetails.dcMobileNo ?
                    <div>
                      <span className="text-gray-400 text-sm"> DC mobile number: </span>
                      <div>
                        {this.state.apptDetails.dcMobileNo}
                      </div>
                    </div>
                    : ''
                }


                {this.state.apptDetails.primaryContactName ?
                  <div>
                    <span className="text-gray-400 text-sm"> Primary contact name : </span>
                    <div>
                      {this.state.apptDetails.primaryContactName}
                    </div>
                  </div>
                  : ''}


                {this.state.apptDetails.primaryContactNo ?
                  <div>
                    <span className="text-gray-400 text-sm"> Primary contact number : </span>
                    <div>
                      {this.state.apptDetails.primaryContactNo}
                    </div>
                  </div>
                  : ''}



                {this.state.apptDetails.dcLandlineNo ?
                  <div>
                    <span className="text-gray-400 text-sm"> Landline number: </span>
                    <div>
                      {this.state.apptDetails.dcLandlineNo}
                    </div>
                  </div> : ''}


                {this.state.apptDetails.spoC_ContactNumber ?
                  <div>
                    <span className="text-gray-400 text-sm"> Sponsored No : </span>
                    <div>
                      {this.state.apptDetails.spoC_ContactNumber}
                    </div>
                  </div> : ''}

                {this.state.apptDetails.primaryEmail ?
                  <div>
                    <span className="text-gray-400 text-sm"> Primary mail : </span>
                    <div>
                      {this.state.apptDetails.primaryEmail}
                    </div>
                  </div>
                  : ''}

                {
                  this.state.visitTypeData.doctorName ?
                    <div>
                      <span className="text-gray-400 text-sm"> Doctor name: </span>
                      <div>
                        {this.state.visitTypeData.doctorName}
                      </div>
                    </div>
                    : ''
                }
                {
                  this.state.apptDetails.additionalInformation.grade != null && this.state.apptDetails.additionalInformation.grade.length > 0 ?
                    <div>
                      <span className="text-gray-400 text-sm"> DC Grading : </span>
                      {
                        this.state.apptDetails.additionalInformation.grade.toLowerCase().includes('a') || this.state.apptDetails.additionalInformation.grade.toLowerCase().includes('b') ?
                          <div>
                            Premium
                          </div>
                          : this.state.apptDetails.additionalInformation.grade.toLowerCase().includes('c') || !this.state.apptDetails.additionalInformation.grade.toLowerCase().includes('d') ?
                            <div>
                              Non Premium
                            </div> : ''
                      }
                    </div>
                    : ''
                }

              </div>
            </div>
          </div>
          : ''}
      </div>
    )
  }

  renderHomeVisit() {
    return (
      <div>
        {this.state.isVisitType && this.state.visitTypeData ?
          <div className="border-2 border-gray-300 p-4 pb-5 w-full text-gray-100 tag-background-card-brown rounded-xl">
            <div>
              <div className="w-full text-center py-4 uppercase text-lg font-bold">
                Home Visit Details
                <div className="h-px mt-1"></div>
              </div>
              <div>
                <div> <span className="text-gray-400 text-sm">Address :</span>
                  <div>
                    {this.state.visitTypeData.addressLine1}
                    {
                      this.state.visitTypeData.addressLine2 != null && this.state.visitTypeData.addressLine2 !== '' ?
                        <span> , {this.state.visitTypeData.addressLine2} </span> : ''
                    }
                  </div>
                </div>
                {
                  this.state.apptDetails && this.state.apptDetails.additionalInformation.additionals.PinCode ?
                    <div> <span className="text-gray-400 text-sm">Pincode :</span>
                      <div>
                        {this.state.apptDetails.additionalInformation.additionals.PinCode}</div>
                    </div>
                    : ''
                }
              </div>
            </div>
          </div>
          : ''}
      </div>
    )
  }

  renderClientOnsiteLocation() {
    return (
      <div>
        {this.state.visitTypeData && this.state.visitTypeData.clientLocation !== "" && this.state.visitTypeData.clientLocation != null ?
          <div className="border-2 border-gray-300 p-4 pb-5 w-full text-gray-100 tag-background-card-brown rounded-xl">
            <div>
              <div className="w-full text-center py-4 uppercase text-lg font-bold">
                Client Onsite Location
                <div className="h-px mt-1"></div>
              </div>

              <div>
                <span className="text-gray-400 text-sm">Location :</span>
                <div>
                  {this.state.visitTypeData.clientLocation}
                </div>
              </div>
            </div>
          </div>
          : ''}
      </div>
    )
  }

  renderAgentDetails() {
    return (
      <div>
        {this.state.visitTypeData && this.state.visitTypeData.productType === 4625 ?
          <div className="border-2 border-gray-300 p-4 pb-5 w-full text-gray-100 tag-background-card-brown rounded-xl">
            <div>
              <div className="w-full text-center py-4 uppercase text-lg font-bold">
                Agent details
                <div className="h-px mt-1"></div>
              </div>

              <div>
                <span className="text-gray-400 text-sm">Name :</span>
                <div>
                  {this.state.visitTypeData.agentName}
                </div>
              </div>

              <div>
                <span className="text-gray-400 text-sm">Mobile :</span>
                <div>
                  {this.state.visitTypeData.agentMobileNumber}
                </div>
              </div>

              <div>
                <span className="text-gray-400 text-sm">Agent code :</span>
                <div>
                  {this.state.visitTypeData.agentCode}
                </div>
              </div>

              <div>
                <span className="text-gray-400 text-sm">Insurer :</span>
                <div>
                  {this.state.visitTypeData.primaryEntityName}
                </div>
              </div>

            </div>
          </div>
          : ''}
      </div>
    )
  }

  renderAdditionals() {
    return (
      <div>
        {this.state.historyDetails && this.state.historyDetails.requestHistory?.additionalInformation?.additionals ?
          <div className="border-2 border-gray-300 p-4 pb-5 w-full text-gray-100 tag-background-card-blue rounded-xl">
            <div>
              <div className="w-full text-center py-4 uppercase text-lg font-bold">
                Additional Info
                <div className="h-px mt-1"></div>
              </div>
              <div>

                {/* Dynamic fields from additionals */}
                <div className="mt-4">
                  {Object.entries(this.state.historyDetails.requestHistory.additionalInformation.additionals).map(
                    ([key, value]) => (
                      <div key={key} className="mt-2">
                        <span className="text-gray-400 text-sm">{key}:</span>
                        <div>{String(value)}</div>
                      </div>
                    )
                  )}
                </div>
              </div>
            </div>
          </div>
          : ''}
      </div>
    )
  }

  showIcon = (icon) => {
    switch (icon) {
      case "sms":
        return { icon: <ChatIcon></ChatIcon>, type: "SMS" }
        break;
      case "email":
        return { icon: <EmailIcon></EmailIcon>, type: "Email" }
        break;
      case "whatsapp":
        return { icon: <WhatsAppIcon></WhatsAppIcon>, type: "WhatsApp" }
        break;
      case "call":
        return { icon: <CallIcon></CallIcon>, type: "Call" }
        break;
      default:
        return { icon: <HeadsetMicIcon></HeadsetMicIcon>, type: "Others" }
        break;
    }
  }

  render() {
    return (
      <Box sx={{ flexGrow: 1, minHeight: '100vh' }}>
        <Grid container className="p-4" spacing={2}>
          <Grid item xs={12} md={4}>
            <Card sx={{ with: '100%', marginBottom: '10px', backgroundColor: '#fcfcfc', borderRadius: '10px' }} >
              <CardContent style={{ padding: '0px' }}>
                {this.state.historyDetails && this.state.historyDetails.requestHistory && this.state.historyDetails.requestHistory.additionalInformation ?
                  <div className="border-2 border-gray-300 p-4 rounded tag-background-card-brown shadow-lg rounded-xl">
                    <button onClick={() => this.props.history.goBack()} className="back-btn p-2 font-bold text-gray-900 border border-2 border-gray-800 bg-gray-100	  rounded-full ">
                      <ArrowLeftOutlinedIcon />
                    </button>

                    {
                      this.state.apptDetails && this.state.apptDetails.isDND ?
                        <div className="flex justify-center float-right bg-gray-100 rounded text-xs p-1 rounded-lg">
                          <div className="text-red-500"><DoNotDisturbIcon></DoNotDisturbIcon></div>
                          <div className="px-2 m-auto font-semibold">
                            DO NOT DISTURB
                          </div>
                        </div> :
                        this.state.apptDetails && this.state.apptDetails.isDNDCustomer ?
                          <div className="flex justify-center float-right bg-gray-100 rounded text-xs p-1 rounded-lg">
                            <div className="text-red-500"><DoNotDisturbIcon></DoNotDisturbIcon></div>
                            <div className="px-2 m-auto font-semibold">
                              DO NOT DISTURB
                            </div>
                          </div> : ''

                    }
                    <div>
                      <span className="text-gray-300 text-sm"> Request ID : </span>
                      <span className="text-gray-100 font-semibold">{this.state.requestId}</span>
                    </div>
                    <div>
                      {
                        this.state.historyDetails.requestHistory.additionalInformation.isPaid ? <span> <span className="text-gray-300 text-sm">Cost Type : </span> <span className="text-gray-100 font-semibold">Paid</span> </span> : !this.state.historyDetails.requestHistory.additionalInformation.isPaid ? <span> <span className="text-gray-300 text-sm">Cost Type : </span> <span className="text-gray-100 font-semibold"> Sponsored </span>  </span> : ''
                      }
                    </div>
                    <div>
                      <span className="text-gray-300 text-sm">Visit Type : </span> <span className="text-gray-100 font-semibold">{this.state.visitType === 'Home_Visit' ? 'Home Visit' : this.state.visitType === "Appointment" ? 'Center Visit' : ''} </span>
                    </div>

                    <div>
                      <span className="text-gray-300 text-sm"> Test Categories : </span>
                      <span className="text-gray-100 font-semibold">
                        {this.state.historyDetails.requestHistory.additionalInformation.productName}
                      </span>
                    </div>
                    <div>
                      <span className="text-gray-300 text-sm"> Source : </span>
                      <span className="text-gray-100 font-semibold">
                        {this.state.source}
                      </span>
                    </div>
                  </div> : ''
                }
              </CardContent>
            </Card>

            <Card sx={{ with: '100%', marginBottom: '10px', backgroundColor: '#fcfcfc', borderRadius: '10px' }} >
              <CardContent style={{ padding: '0px' }}>
                {
                  this.state.communicationHistory && Object.keys(this.state.communicationHistory).length != 0 &&
                  <div className="border-2 border-gray-300 p-4 pb-5 w-full text-gray-100 tag-background-card-blue rounded-xl">
                    <div>
                      <div className="w-full text-left pb-2  text-sm font-bold">
                        Communication:
                        <div className="h-px mt-1"></div>
                      </div>
                      <div className="flex" >
                        {
                            Object.keys(this.state.communicationHistory).map(ele => {
                            const a = InsurerErIDs[ele.toLowerCase()];
                            if (a && a.includes(this.state.primaryEntityId)) {
                              return null;
                            }
                            let icon = this.showIcon(ele.toLowerCase())
                            return (
                              <div onClick={() => this.setState({ showCommunicationModal: true })} className=" cursor-pointer border border-gray-500 text-gray-200 font-semibold text-center rounded-3xl shadow-inner text-sm cursor-pointer mr-1 h-full">
                                <Tooltip title={icon.type}>
                                  <div className="p-1 mx-1">
                                    <span className="mr-2">
                                      {icon.icon}
                                    </span>
                                    <span className="text-blue-800	font-bold rounded-3xl px-1 bg-gray-300 text-sm">
                                      {this.state.communicationHistory[ele]}
                                    </span>
                                  </div>
                                </Tooltip>
                              </div>
                            )
                          })
                        }
                      </div>
                    </div>
                  </div>
                }
              </CardContent>
            </Card>

            <Card sx={{ with: '100%', marginBottom: '10px', backgroundColor: '#fcfcfc', borderRadius: '10px' }}>
              <CardContent style={{ padding: '0px' }}>
                {this.renderCustomerDetails()}
              </CardContent>
            </Card>

            <Card sx={{ with: '100%', marginBottom: '10px', backgroundColor: '#fcfcfc', borderRadius: '10px' }}>
              <CardContent style={{ padding: '0px' }}>
                {this.renderAppointmentDetails()}
              </CardContent>
            </Card>

            {this.state.isVisitType ?
              <Card sx={{ with: '100%', marginBottom: '10px', backgroundColor: '#fcfcfc', borderRadius: '10px' }}>
                <CardContent style={{ padding: '0px' }}>
                  {this.renderHomeVisit()}
                </CardContent>
              </Card>
              : ''}
            {!this.state.dcLogin ?
              <Card sx={{ with: '100%', marginBottom: '10px', backgroundColor: '#fcfcfc', borderRadius: '10px' }}>
                <CardContent style={{ padding: '0px' }}>
                  {this.renderClientOnsiteLocation()}
                </CardContent>
              </Card>
              : ''}

            {this.state.visitTypeData && this.state.visitTypeData.productType === 4625 ?
              <Card sx={{ with: '100%', marginBottom: '10px', backgroundColor: '#fcfcfc', borderRadius: '10px' }}>
                <CardContent style={{ padding: '0px' }}>
                  {this.renderAgentDetails()}
                </CardContent>
              </Card>
              : ''}

            {this.state.historyDetails && this.state.historyDetails.requestHistory.additionalInformation.additionals ?
              <Card sx={{ with: '100%', marginBottom: '10px', backgroundColor: '#fcfcfc', borderRadius: '10px' }}>
                <CardContent style={{ padding: '0px' }}>
                  {this.renderAdditionals()}
                </CardContent>
              </Card>
              : ''}

          </Grid>

          <Grid item xs={12} md={8}>
            {
              this.state.statusHistory && this.state.statusHistory.length > 0 ? <ShowCorresponseProvider apptHistory={this.state.apptHistory} statusHistory={this.state.statusHistory}></ShowCorresponseProvider> : ''

            }
          </Grid>
        </Grid>

        <Dialog
          open={this.state.showCommunicationModal}
          onClose={(event, reason) => {
            if (reason !== 'backdropClick') {
              this.setState({ showCommunicationModal: false })
            } else return false;
          }}
          fullWidth={true}
          maxWidth={'md'}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle style={{ background: "rgb(245 245 245)" }}>
            <div className="flex justify-between">
              <div className="font-semibold">
                <span className="cursor-pointer">
                  Communication History
                </span>
                {
                  this.state.requestId ?
                    <div className="text-xs text-gray-500">
                      Request ID <span className="font-semibold">{this.state.requestId} </span>
                    </div> : <></>
                }

              </div>
              <div className="text-gray-500" onClick={() => this.setState({ showCommunicationModal: false })}>
                <span className="cursor-pointer">
                  <CloseIcon></CloseIcon>
                </span>
              </div>
            </div>

          </DialogTitle>
          <DialogContent>
            <ShowCommunicationHistory details={{ id: this.state.requestId }}></ShowCommunicationHistory>
          </DialogContent>
        </Dialog>

      </Box>

    )
  }
}
export default RequestProviderHistory;
